<ngb-accordion #acc="ngbAccordion">
    <ng-container *ngFor="let n of programs">
        <ngb-panel [title]="n.program.Name">
            <ng-template ngbPanelContent>
                <section class="block-em mt-0">
                    <header class="block-header">
                        <h3>{{'portfolio_programs_info' | translate}}</h3>
                    </header>
                    <div class="row">
                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblCode' | translate}}</label>
                            <div>{{n.program.Code}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblStatus' | translate}}</label>
                            <div>{{n.program.Status}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblFlow' | translate}}</label>
                            <div>{{n.program.Flow}}</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblStudyType' | translate}}</label>
                            <div>{{n.program.StudyType}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblStudyForm' | translate}}</label>
                            <div>{{n.program.StudyForm}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblLevel' | translate}}</label>
                            <div>{{n.program.Level}}</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblVolumeEcts' | translate}}</label>
                            <div>{{n.program.PlanEcts == undefined ? ('portfolio_noData' | translate) : n.program.PlanEcts}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblDurationSemesters' | translate}}</label>
                            <div>{{n.program.DurationSemesters}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblDurationYears' | translate}}</label>
                            <div>{{n.program.DurationYears}}</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblDirector' | translate}}</label>
                            <div>{{n.program.Director}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblImplementer' | translate}}</label>
                            <div>{{n.program.Implementer}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblLanguage' | translate}}</label>
                            <div>{{n.program.Language}}</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblDegree' | translate}}</label>
                            <div>{{n.program.Degree}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblQualification' | translate}}</label>
                            <div>{{n.program.Qualification}}</div>
                        </div>

                        <div class="data-value col-md">
                            <label>{{'portfolio_programs_lblProfession' | translate}}</label>
                            <div>{{n.program.Profession}}</div>
                        </div>
                    </div>
                </section>

                <section class="block-em">
                    <header class="block-header">
                        <h3>{{'portfolio_programs_courses' | translate}}</h3>
                    </header>

                    <app-table [columns]="courseColumns" [rows]="n.coursesBySemester" [style]="'plain'" [pageSize]="1000">
                        <ng-template #rowTemplate let-row>
                            <tr>
                                <td colspan="99" class="semester-row" (click)="row.isExpanded = !row.isExpanded">
                                    <div class="semester-header">
                                        <i class="fi fi-rs-angle-up" *ngIf="row.isExpanded"></i>
                                        <i class="fi fi-rs-angle-right" *ngIf="!row.isExpanded"></i>

                                        <div class="semester-info">
                                            <div class="semester-index">{{row.semester.Index}}</div>
                                            <div>
                                                <div class="semester-name">{{row.semester.Name}}</div>
                                                <div class="semester-date">{{row.semester.StartDate}} - {{row.semester.EndDate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <ng-container *ngIf="row.isExpanded">
                                <tr *ngFor="let c of row.courses">
                                    <td class="hidden-sm-down">{{c.Category}}</td>
                                    <td>
                                        <div class="text-top">{{c.Code}}</div>
                                        <div>{{c.Name}}</div>
                                        <div class="text-sub">{{c.Faculty}}</div>
                                        <div class="hidden-md-up mt-1 text-sub">
                                            <div>
                                                <label>{{'portfolio_programs_lblBlock' | translate}}</label>: {{c.Category}}
                                            </div>
                                            <div>
                                                <label>{{'portfolio_programs_lblEcts' | translate}}</label>: {{c.Ects}} ({{c.CreditPoints}} KP)
                                            </div>
                                            <div>
                                                <label>{{'portfolio_programs_lblExamType' | translate}}</label>: {{c.ExamType}}
                                            </div>
                                            <div *ngIf="c.MarkDate">
                                                <label>{{'portfolio_programs_lblGrade' | translate}}</label>:
                                                {{c.Mark || c.MarkText}} ({{c.MarkDate | appDate}}, {{c.Teacher}})
                                            </div>
                                        </div>
                                    </td>
                                    <td class="hidden-sm-down">
                                        <div class="text-nowrap">{{c.Ects}} ({{c.CreditPoints}} KP)</div>
                                        <div class="text-sub text-nowrap">{{c.ExamType}}</div>
                                    </td>
                                    <td class="hidden-sm-down">
                                        <ng-container *ngIf="c.MarkDate">
                                            <div class="badge" [class.text-bg-primary]="c.Mark" [class.text-bg-info]="!c.Mark">{{c.Mark || c.MarkText}}</div>
                                            <div>{{c.MarkDate | appDate}}</div>
                                            <div class="text-sub text-nowrap">{{c.Teacher}}</div>
                                        </ng-container>
                                    </td>
                                    <td>
                                        <div class="table-actions">
                                            <a class="btn btn-outline btn-icon"
                                               [class.disabled]="!canOpenGrades"
                                               [routerLink]="['/marks'] | localize"
                                               [queryParams]="{ id: studentId }"
                                               [ngbTooltip]="'portfolio_programs_gradesHint' | translate"
                                               target="_blank">
                                                <i class="fi fi-rs-text-check"></i>
                                            </a>

                                            <a class="btn btn-outline btn-icon"
                                               [class.disabled]="!canOpenEqualizations"
                                               [routerLink]="['/student-course-equalizations'] | localize"
                                               [queryParams]="{ id: studentId }"
                                               [ngbTooltip]="'portfolio_programs_equalizationHint' | translate"
                                               target="_blank"
                                               *ngIf="!c.Mark && !c.MarkText">
                                                <i class="fi  fi-rs-shuffle"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-template>
                    </app-table>
                </section>

                <section class="block-em mb-0">
                    <header class="block-header">
                        <h3>{{'portfolio_programs_summary' | translate}}</h3>
                    </header>

                    <div class="summary">
                        <div class="chart">
                            <svg width="160" height="160" viewBox="0 0 160 160">
                                <circle class="chart-bar" r="70" cx="80" cy="80"></circle>
                                <circle class="chart-fill" r="70" cx="80" cy="80"
                                        [attr.stroke-dasharray]="2 * 3.14 * 70 + 'px'"
                                        [attr.stroke-dashoffset]="2 * 3.14 * 70 * (1 - (n.program.FactEcts || 0) / (n.program.PlanEcts || 1000000)) + 'px'"></circle>
                            </svg>
                            <div class="chart-data">
                                <div class="chart-progress">{{n.program.FactEcts}}</div>
                                <div class="chart-total">{{n.program.PlanEcts}}</div>
                            </div>
                        </div>

                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{'portfolio_programs_lblEcts' | translate}}</th>
                                        <th>{{'portfolio_programs_lblPlanned' | translate}}</th>
                                        <th>{{'portfolio_programs_lblFact' | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>A</td>
                                        <td>{{getEctsDisplay(n.program.PlanEctsA)}}</td>
                                        <td>{{getEctsDisplay(n.program.FactEctsA)}}</td>
                                    </tr>

                                    <tr>
                                        <td>B</td>
                                        <td>{{getEctsDisplay(n.program.PlanEctsB)}}</td>
                                        <td>{{getEctsDisplay(n.program.FactEctsB)}}</td>
                                    </tr>

                                    <tr>
                                        <td>C</td>
                                        <td>{{getEctsDisplay(n.program.PlanEctsC)}}</td>
                                        <td>{{getEctsDisplay(n.program.FactEctsC)}}</td>
                                    </tr>

                                    <tr class="total-row">
                                        <td>{{'portfolio_programs_lblTotal' | translate}}</td>
                                        <td>{{getEctsDisplay(n.program.PlanEcts)}}</td>
                                        <td>{{getEctsDisplay(n.program.FactEcts)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </ng-template>
        </ngb-panel>
    </ng-container>
</ngb-accordion>
